import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="relative overflow-hidden" data-id="element-98">
      {/* Warm gradient background */}
      <div className="absolute inset-0 bg-ink-900" data-id="element-99" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#2a1f1f]/40 via-ink-900/80 to-ink-900" data-id="element-100" />
      <div className="absolute top-0 left-0 right-0 h-[300px] bg-gradient-to-b from-[#3d2020]/20 to-transparent pointer-events-none" data-id="element-101" />
      <div className="absolute top-0 right-0 w-[600px] h-[400px] bg-gradient-radial from-[#4a2828]/15 to-transparent rounded-full blur-3xl -translate-y-1/2 translate-x-1/4 pointer-events-none" data-id="element-102" />

      {/* Animated gold line separator */}
      <div className="relative" data-id="element-103">
        <motion.div className="h-[1px] bg-gradient-to-r from-transparent via-accent-400 to-transparent" initial={{
        scaleX: 0,
        opacity: 0
      }} whileInView={{
        scaleX: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.5,
        ease: 'easeInOut'
      }} data-id="element-104" />
      </div>

      <div className="relative z-10 py-16 md:py-20" data-id="element-105">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-106">
          {/* Col 1 — Brand */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-107">
            <div className="mb-4" data-id="element-108">
              <h2 className="font-serif text-[26px] tracking-[0.15em] font-black text-sage-50 leading-none" data-id="element-109">
                BOARDLINE
              </h2>
              <span className="text-[9px] uppercase tracking-[0.3em] text-sage-400 font-medium mt-1 block" data-id="element-110">
                Executive Advisory
              </span>
            </div>
            <p className="text-sm text-sage-300/80 leading-relaxed max-w-[260px]" data-id="element-111">
              Partnering with senior leaders to navigate career transitions with
              precision, discretion, and unmatched expertise.
            </p>
          </motion.div>

          {/* Col 2 — Navigation */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-112">
            <h3 className="text-sm font-serif font-bold text-accent-400 mb-6 tracking-wide" data-id="element-113">
              Navigation
            </h3>
            <div className="flex flex-col space-y-3.5 text-sm text-sage-300/80" data-id="element-114">
              <a href="#" className="hover:text-white transition-colors duration-300" data-id="element-115">
                Home
              </a>
              <a href="#about" className="hover:text-white transition-colors duration-300" data-id="element-116">
                About Us
              </a>
              <a href="#services" className="hover:text-white transition-colors duration-300" data-id="element-117">
                Services
              </a>
              <a href="#insights" className="hover:text-white transition-colors duration-300" data-id="element-118">
                Executive Trends
              </a>
              <a href="#hidden" className="hover:text-white transition-colors duration-300" data-id="element-119">
                Hidden Market
              </a>
            </div>
          </motion.div>

          {/* Col 3 — Services */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-120">
            <h3 className="text-sm font-serif font-bold text-accent-400 mb-6 tracking-wide" data-id="element-121">
              Services
            </h3>
            <div className="flex flex-col space-y-3.5 text-sm text-sage-300/80" data-id="element-122">
              <a href="#services" className="hover:text-white transition-colors duration-300" data-id="element-123">
                Job Board Advising
              </a>
              <a href="#hidden" className="hover:text-white transition-colors duration-300" data-id="element-124">
                Hidden Market Access
              </a>
              <a href="#services" className="hover:text-white transition-colors duration-300" data-id="element-125">
                Career Guidance
              </a>
            </div>
          </motion.div>

          {/* Col 4 — Contact with icons */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-126">
            <h3 className="text-sm font-serif font-bold text-accent-400 mb-6 tracking-wide" data-id="element-127">
              Contact
            </h3>
            <div className="flex flex-col space-y-5" data-id="element-128">
              <a href="mailto:simeonpraymond@boardlineexecutiveadvisory.com" className="flex items-start gap-3 group" data-id="element-129">
                <Mail className="w-4 h-4 text-accent-400 mt-0.5 flex-shrink-0" data-id="element-130" />
                <span className="text-sm text-sage-300/80 group-hover:text-white transition-colors duration-300 break-all leading-relaxed" data-id="element-131">
                  simeonpraymond@boardlineexecutiveadvisory.com
                </span>
              </a>
              <a href="tel:9208174367" className="flex items-center gap-3 group" data-id="element-132">
                <Phone className="w-4 h-4 text-accent-400 flex-shrink-0" data-id="element-133" />
                <span className="text-sm text-sage-300/80 group-hover:text-white transition-colors duration-300" data-id="element-134">
                  (920) 817-4367
                </span>
              </a>
              <div className="flex items-start gap-3" data-id="element-135">
                <MapPin className="w-4 h-4 text-accent-400 mt-0.5 flex-shrink-0" data-id="element-136" />
                <div data-id="element-137">
                  <p className="text-sm text-sage-300/80" data-id="element-138">Madison, Wisconsin</p>
                  <p className="text-xs text-sage-400/60 italic mt-1" data-id="element-139">
                    Serving Clients Globally
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Bottom bar with animated separator */}
        <div className="max-w-7xl mx-auto px-6 md:px-12 mt-16" data-id="element-140">
          <motion.div className="h-[1px] bg-white/[0.06]" initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.4
        }} data-id="element-141" />
          <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-142">
            <motion.p className="text-xs text-sage-400/50" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.6
          }} data-id="element-143">
              &copy; 2026 Boardline Executive Advisory. All rights reserved.
            </motion.p>

            {/* Animated compass accent */}
            <motion.div className="flex items-center gap-3" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.8
          }} data-id="element-144">
              <motion.div className="relative w-8 h-8" animate={{
              rotate: 360
            }} transition={{
              repeat: Infinity,
              duration: 20,
              ease: 'linear'
            }} data-id="element-145">
                <svg viewBox="0 0 32 32" fill="none" className="w-full h-full" data-id="element-146">
                  <circle cx="16" cy="16" r="14" stroke="#B89B5E" strokeWidth="0.5" opacity="0.4" data-id="element-147" />
                  <circle cx="16" cy="16" r="10" stroke="#B89B5E" strokeWidth="0.3" opacity="0.2" data-id="element-148" />
                  {/* N needle */}
                  <polygon points="16,4 17.5,16 16,14.5 14.5,16" fill="#B89B5E" opacity="0.6" data-id="element-149" />
                  {/* S needle */}
                  <polygon points="16,28 17.5,16 16,17.5 14.5,16" fill="#D4BF8A" opacity="0.2" data-id="element-150" />
                  <circle cx="16" cy="16" r="2" fill="#B89B5E" opacity="0.5" data-id="element-151" />
                  <circle cx="16" cy="16" r="1" fill="#D4BF8A" opacity="0.8" data-id="element-152" />
                </svg>
              </motion.div>
              <span className="text-[10px] uppercase tracking-[0.2em] text-sage-400/40" data-id="element-153">
                Guiding Legacies
              </span>
            </motion.div>
          </div>
        </div>
      </div>
    </footer>;
}